import Vuex from 'vuex';
import Vue from 'vue';
import maps from './modules/map';
import compositeDataset from './modules/compositeDataset';
import dashboards from './modules/dashboards';
import map2 from './modules/map2';
import statistics from './modules/statistics';

// Load Vuex
Vue.use(Vuex);

// Create store
export default new Vuex.Store({
  modules: {
    maps,
    compositeDataset,
    dashboards,
    map2,
    statistics,
  },
});
